import Vue from "vue";

const success = (context, response) => {
  context.promoCodeError = false;
  context.promoCodeApplying = false;
  context.promoCodeApplied = true;
  context.promoData = response.promoCode;
  let priceWithPromo =
    response.promoCode.type === "percent"
      ? context.bookingDetail.price -
        (context.bookingDetail.price * response.promoCode.percent) / 100
      : context.bookingDetail.price - response.promoCode.amount;
  priceWithPromo = priceWithPromo < 0 ? 0 : priceWithPromo;
  priceWithPromo = Math.round(priceWithPromo * 100) / 100;
  context.totalWithPromo =
    priceWithPromo + context.rental.cleaning + context.bookingDetail.city_taxes;

  context.pricePerNight = priceWithPromo;
  context.pricePerNight =
    Math.round((priceWithPromo / context.duration) * 100) / 100;
  context.initialPrice = priceWithPromo;
  context.priceWithPromo = priceWithPromo;
  toastr.success(context.$t("booking.promo.added"));
};

const failed = (error, context) => {
  context.promoCodeError = true;
  context.promoCodeApplying = false;
  context.promoCodeApplied = false;
  context.promoData = {};
  context.initialPrice = null;
  context.totalWithPromo = null;
  context.priceWithPromo = null;
  context.pricePerNight = parseFloat(
    context.bookingDetail.price / context.duration
  ).toFixed(2);
};

export default (context, data) =>
  Vue.$http
    .post("/apply-promo-code", data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/applyPromoCode.js